<template>
  <div class=" mt-4">
    <div class="container-bg-white">
      <div class="row p-3">
        <div class="col-9 text-28 text-bold">
          {{ $t('flexben.import_history.import_summary') }} {{ $t('flexben.import.types.' + importType).toLowerCase() }}
        </div>
        <div class="col-3 " v-if="isScheduledImport()">
          <div class="w-100  d-inline float-right" >
            <div class="form-group">
              <div class="w-100 d-inline-flex" :class="{ 'schedule-request-date-disabled': disabledEditScheduledImport() }">
                <label for="schedule_request_date" class="my-auto col-form-label">
                  <font-awesome-icon icon="calendar-alt" class="text-24 mr-2 text-themed "/>
                </label>
                <date-range-picker
                  id="schedule_request_date"
                  ref="picker"
                  v-model="proxyScheduledAt"
                  :append-to-body="false"
                  :disabled="disabledEditScheduledImport()"
                  :min-date="minDateScheduled"
                  :max-date="pickerMaxDate"
                  :single-date-picker="true"
                  :time-picker="true"
                  :time-picker24-hour="true"
                  :time-picker-increment="60"
                  :show-dropdowns="false"
                  :linked-calendars="false"
                  :auto-apply="false"
                  :ranges="false"
                  :date-format="scheduleDateFormat"
                  :locale-data="{
                    format: 'DD-MM-YYYY HH:mm',
                    firstDay: 1,
                    applyLabel: 'Aplica',
                    cancelLabel: 'Anuleaza',
                  }"
                  class="form-control-d w-100 color-orange "
                >
                </date-range-picker>

              </div>
            </div>
          </div>
        </div>

        <div v-for="(item, index) in summary_list" :key="index" class="col-12 col-md-6 col-lg-4 mt-3">
          <span class="text-bold float-left w-65">{{ item.text }}</span>
          <div class="float-right pr-5 w-35 ">
            <span :class="item.value_class" class="mr-2">{{ item.value }}</span>
            <span class="cursor-pointer"
                  @click="setQuickFilter(item.quick_filter); filterValues();">
               <filter-icon v-if="item.quick_filter!==null"
                            :filter-class="item.quick_filter_class"></filter-icon>
            </span>

          </div>
        </div>
        <div v-if="importType==='beneficiary'" class="col-12 mt-4 text-dark">
          {{ $t('flexben.import.summary.notice_new_beneficiary') }}
        </div>
      </div>
    </div>
    <div class="container-bg-white mt-3">
      <ImportReviewFilters :filters="importData.filters"
                           :importFilterValues="importFilterValues"
                           @filterValues="filterValues"/>
    </div>
    <div class="container-bg-white mt-3">
      <div class="row p-3">
        <div class="col-12 text-28 text-bold">
          {{$t("flexben.import.entries")}}
        </div>
        <div :key="tableKey" class="col-12">
          <component :is="tableComponentName"
                     :importDeleteItemIds="importData.importDeleteItemIds"
                     :importFormOptions="importData.form_options"
                     :importItems="importData.items.data"
                     :ts_month="importData.import.ts_month"
                     :ts_year="importData.import.ts_year"
                     @checkForDelete="checkForDelete"
                     @editItem="editItem"
                     @disabledEditScheduledImport="disabledEditScheduledImport"></component>
        </div>
        <div class="col-12 p-0">
          <button :disabled="(importData.importDeleteItemIds.length === 0) || disabledEditScheduledImport()"
                  class="btn text-danger"
                  @click="dropImportItems()">
            <font-awesome-icon class="mr-2" icon="trash-alt"/>
            {{ $t('flexben.import.buttons.delete_button',{ count:importData.importDeleteItemIds.length }) }}
          </button>
        </div>

        <div class="col-12 p-0">
          <listPagination
            :currentPage="importData.items.current_page"
            :endItem="importData.items.to"
            :itemsPerPage="importData.items.perPage"
            :startItem="importData.items.from"
            :totalItems="importData.items.total"
            @changePerPage="changePerPage"
            @pageChanged="pageChanged"></listPagination>
        </div>
      </div>
    </div>
    <component :is="editModalComponentName"
               v-if="openModalEditItem"
               :filters="importData.filters"
               :importFormOptions="importData.form_options"
               :importType="importType"
               :item_data="editItemData"
               @closeModal="closeModal"
               @dropImportItem="dropImportItem"
               @updateImportItem="updateImportItem"></component>
  </div>
</template>

<script>
import ImportTableBeneficiary from "./tables/ImportTableBeneficiary";
import ImportTableBudget from "./tables/ImportTableBudget";
import ImportTableTimesheet from "./tables/ImportTableTimesheet";
import ImportReviewFilters from "./ImportReviewFilters";
import ImportTableOfferBeneficiary from "./tables/ImportTableOfferBeneficiary";
import ImportTablePPP3 from "@/components/flexben/import/partials/tables/ImportTablePPP3";
import EditBeneficiaryModal from "../modals/EditBeneficiaryModal";
import EditBudgetModal from "../modals/EditBudgetModal";
import EditTimeSheetModal from "../modals/EditTimeSheetModal";
import EditPpp3Modal from "../modals/Ppp3Modal.vue";
import FilterIcon from "../../../fragments/FilterIcon";
import EditOfferBeneficiaryModal from "../modals/EditOfferBeneficiaryModal";
import ImportTableUpdateBeneficiary from "@/components/flexben/import/partials/tables/ImportTableUpdateBeneficiary.vue";
import EditUpdateBeneficiariesModal from "@/components/flexben/import/modals/EditUpdateBeneficiariesModal.vue";
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import moment from "moment";

export default {
  name: "ReviewImport",
  components: {
    FilterIcon,
    EditTimeSheetModal,
    EditBudgetModal,
    EditBeneficiaryModal,
    EditUpdateBeneficiariesModal,
    EditPpp3Modal,
    ImportReviewFilters,
    ImportTableTimesheet,
    ImportTableBudget,
    ImportTableBeneficiary,
    ImportTableUpdateBeneficiary,
    EditOfferBeneficiaryModal,
    ImportTableOfferBeneficiary,
    ImportTablePPP3,
    DateRangePicker
  },
  props: {
    importType: {
      type: String,
      default: function () {
        return '';
      },
      required: true
    },
    openModalEditItem: {
      type: Boolean,
      default: false,
      required: true
    },
    importData: {
      type: Object,
      default: function () {
        return {
          import: {},
          totals: {},
          filters: {},
          items: {},
          form_options: {max_working_days_month: 0},
          importDeleteItemIds: [],
        };
      },
      required: true,
    },
    unfinishedImport: {
      type: Boolean,
      default: function () {
        return false;
      },
      required: true
    },
    importFilterValues: {
      type: Object,
      default: function () {
        return {
          department: null,
          job_title: null,
          cost_center: null,
          working_point: null,
          benefit_category_code: null,
          status: 'all',
          invitation_channel: null,
        }
      },
      required: true,
    },
    updateItemResponse: {
      type: Object,
      required: true,
      default: function () {
        return {};
      }
    },
    tableKey: {
      type: Number,
      required: true,
      default: 0
    },
  },
  data() {
    const now = moment();
    return {
      editItemData: {},
      editItemIndex: null,
      tableComponentNames: {
        beneficiaries: 'ImportTableBeneficiary',
        update_beneficiaries: 'ImportTableUpdateBeneficiary',
        offer_beneficiaries: 'ImportTableOfferBeneficiary',
        budgets: 'ImportTableBudget',
        budgets_auto: 'ImportTableBudget',
        telework_budgets: 'ImportTableBudget',
        time_sheets: 'ImportTableTimesheet',
        time_sheets_auto: 'ImportTableTimesheet',
        ppp3: 'ImportTablePPP3'
      },
      editModalComponentNames: {
        beneficiaries: 'EditBeneficiaryModal',
        update_beneficiaries: 'EditUpdateBeneficiariesModal',
        offer_beneficiaries: 'EditOfferBeneficiaryModal',
        budgets: 'EditBudgetModal',
        budgets_auto: 'EditBudgetModal',
        telework_budgets: 'EditBudgetModal',
        time_sheets: 'EditTimeSheetModal',
        time_sheets_auto: 'EditTimeSheetModal',
        ppp3: 'EditPpp3Modal'
      },
      dateFormat: 'dd-MM-yyyy HH:mm',
      minDateScheduled: now.clone().add(2, 'days').startOf('day').toDate(),
      maxDateScheduled: now.clone().add(1, 'month').endOf('day').toDate(),
      scheduledDate: {
        startDate: null,
        endDate: null
      },
    };
  },
  computed: {
    pickerMaxDate() {
      return moment(this.maxDateScheduled).add(1, 'month').toDate();
    },
    proxyScheduledAt: {
      get() {
        this.$emit('scheduledDate', this.importData.import.scheduled_at);
        return {
          startDate: this.importData.import.scheduled_at,
          endDate: this.importData.import.scheduled_at
        }
      },
      set(val) {
        if (!val || !val.startDate) {
          return;
        }
        const withDisplayedTime = this.applyDisplayedPickerTime(val.startDate);
        let selectedMoment = moment(withDisplayedTime);
        const minMoment = moment(this.minDateScheduled);
        const maxMoment = moment(this.maxDateScheduled);

        if (selectedMoment.isBefore(minMoment)) {
          selectedMoment = minMoment;
        }
        if (selectedMoment.isAfter(maxMoment)) {
          selectedMoment = maxMoment;
        }

        const boundedDate = selectedMoment.toDate();
        this.importData.import.scheduled_at = boundedDate;
        this.$emit('scheduledDate', boundedDate);
      }
    },
    summary_list: function () {
      let returnData = [];
      switch (this.importType) {
        case 'beneficiaries':
        case 'update_beneficiaries':
        case 'offer_beneficiaries':
          returnData = [
            {
              text: this.$t('flexben.import.summary.total_items'),
              value_class: '',
              value: this.importData.totals.total_items,
              quick_filter: null,
              quick_filter_class: ''
            },
            {
              text: this.$t('flexben.import.summary.total_valid'),
              value_class: 'text-green',
              value: this.importData.totals.total_valid,
              quick_filter: null,
              quick_filter_class: ''
            },
            {
              text: this.$t('flexben.import.summary.total_invalid'),
              value_class: 'text-danger',
              value: this.importData.totals.total_invalid,
              quick_filter: 'invalid',
              quick_filter_class: 'filter-icon-danger'
            },
            {
              text: this.$t('flexben.import.summary.total_new'),
              value_class: 'text-green',
              value: this.importData.totals.total_new,
              quick_filter: 'new',
              quick_filter_class: 'filter-icon-success'
            },
            {
              text: this.$t('flexben.import.summary.total_duplicate'),
              value_class: 'text-danger',
              value: this.importData.totals.total_duplicate,
              quick_filter: 'duplicate',
              quick_filter_class: 'filter-icon-danger'
            },
            {
              text: this.$t('flexben.import.summary.total_update'),
              value_class: 'text-themed',
              value: this.importData.totals.total_update,
              quick_filter: 'update',
              quick_filter_class: 'filter-icon-warning'
            },
          ];
          break;
        case 'budgets':
        case 'budgets_auto':
        case 'ppp3_budgets':
        case 'telework_budgets':
          returnData = [
            {
              text: this.$t('flexben.import.summary.total_items'),
              value_class: '',
              value: this.importData.totals.total_items,
              quick_filter: null,
              quick_filter_class: ''
            },
            {
              text: this.$t('flexben.import.summary.total_amount'),
              value_class: '',
              value: this.importData.totals.total_budget + ' Lei',
              quick_filter: null,
              quick_filter_class: ''
            },
            {
              text: this.$t('flexben.import.summary.total_valid'),
              value_class: 'text-green',
              value: this.importData.totals.total_valid,
              quick_filter: 'new',
              quick_filter_class: 'filter-icon-success'
            },
            {
              text: this.$t('flexben.import.summary.total_invalid'),
              value_class: 'text-danger',
              value: this.importData.totals.total_invalid,
              quick_filter: 'invalid',
              quick_filter_class: 'filter-icon-danger'
            },
          ];
          break;
        case 'time_sheets':
        case 'time_sheets_auto':
          returnData = [
            {
              text: this.$t('flexben.import.summary.total_items'),
              value_class: '',
              value: this.importData.totals.total_items,
              quick_filter: null,
              quick_filter_class: ''
            },
            {
              text: this.$t('flexben.import.summary.time_sheet_date'),
              value_class: '',
              value: this.$t('orderMonth_' + this.importData.import.ts_month) + ' ' + this.importData.import.ts_year,
              quick_filter: null,
              quick_filter_class: ''
            },
            {
              text: this.$t('flexben.import.summary.total_valid'),
              value_class: 'text-green',
              value: this.importData.totals.total_valid,
              quick_filter: null,
              quick_filter_class: 'filter-icon-success'
            },
            {
              text: this.$t('flexben.import.summary.total_invalid'),
              value_class: 'text-danger',
              value: this.importData.totals.total_invalid,
              quick_filter: 'invalid',
              quick_filter_class: 'filter-icon-danger'
            },
            {
              text: this.$t('flexben.import.summary.total_new'),
              value_class: 'text-green',
              value: this.importData.totals.total_new,
              quick_filter: 'new',
              quick_filter_class: 'filter-icon-success'
            },
            {
              text: this.$t('flexben.import.summary.total_update'),
              value_class: 'text-themed',
              value: this.importData.totals.total_update,
              quick_filter: 'update',
              quick_filter_class: 'filter-icon-warning'
            },
          ];
          break;
        case 'ppp3':
          returnData = [
            {
              text: this.$t('flexben.import.summary.total_items'),
              value_class: '',
              value: this.importData.totals.total_items,
              quick_filter: null,
              quick_filter_class: ''
            },
            {
              text: this.$t('flexben.import.summary.total_valid'),
              value_class: 'text-green',
              value: this.importData.totals.total_valid,
              quick_filter: null,
              quick_filter_class: 'filter-icon-success'
            },
            {
              text: this.$t('flexben.import.summary.total_invalid'),
              value_class: 'text-danger',
              value: this.importData.totals.total_invalid,
              quick_filter: 'invalid',
              quick_filter_class: 'filter-icon-danger'
            },
            {
              text: this.$t('flexben.import.summary.total_new'),
              value_class: 'text-green',
              value: this.importData.totals.total_new,
              quick_filter: 'new',
              quick_filter_class: 'filter-icon-success'
            },
            {
              text: this.$t('flexben.import.summary.total_update'),
              value_class: 'text-themed',
              value: this.importData.totals.total_update,
              quick_filter: 'update',
              quick_filter_class: 'filter-icon-warning'
            },
          ];
          break;
        default:
          break;
      }

      return returnData;
    },
    tableComponentName: function () {
      return this.tableComponentNames[this.importType];
    },
    editModalComponentName: function () {
      return this.editModalComponentNames[this.importType];
    },
  },
  watch: {
    updateItemResponse: function (val) {
      this.editItemData = val;
    },
  },
  methods: {
    checkForDelete(itemId) {
      this.$parent.checkForDelete(itemId);
    },
    pageChanged(page) {
      this.$emit('pageChanged', page)
    },
    filterValues() {
      this.$emit('filterValues');
    },
    dropImportItems() {
      if (this.importData.importDeleteItemIds.length > 0) {
        this.$emit('dropImportItems');
      }
    },
    editItem(itemIndex) {
      this.editItemIndex = itemIndex;
      this.editItemData = {...this.importData.items.data[itemIndex]};
      this.$parent.openModalEditItem = true;
    },
    dropImportItem() {
      this.$parent.openModalEditItem = false;
      this.editItemIndex = null;
      this.$emit('dropSpecificItem', this.editItemData.id);
      this.editItemData = {};
    },
    closeModal() {
      this.$parent.openModalEditItem = false;
      this.editItemData = {};
      this.editItemIndex = null;
    },
    updateImportItem() {
      this.$emit('updateImportItem', this.editItemData);
    },
    changePerPage(perPage) {
      this.$emit('changePerPage', perPage);
    },
    setQuickFilter(status) {
      this.importFilterValues.department = '';
      this.importFilterValues.job_title = '';
      this.importFilterValues.cost_center = '';
      this.importFilterValues.working_point = '';
      this.importFilterValues.benefit_category_code = '';
      this.importFilterValues.status = status;
    },
    getInvalidReasons(invalidReasons) {
      let errorList = [];
      let indexKey, errorField;
      for (errorField in invalidReasons) {
        if (typeof invalidReasons[errorField] === 'string') {
          errorList.push(this.$t('flexben.formFieldError', {
            field: this.$t('flexben.import.table_headings.' + errorField),
            reason: this.$t('flexben.formErrorReasons.' + invalidReasons[errorField])
          }))
        } else {
          for (indexKey in invalidReasons[errorField]) {
            if (invalidReasons[errorField][indexKey] === 'exceeding_max_working_days_month') {
              errorList.push(this.$t('flexben.formFieldError', {
                field: this.$t('flexben.import.table_headings.' + errorField),
                reason: this.$t('flexben.formErrorReasons.' + invalidReasons[errorField][indexKey], {
                  days_nr: this.importData.form_options.max_working_days_month
                })
              }))
            } else {
              errorList.push(this.$t('flexben.formFieldError', {
                field: this.$t('flexben.import.table_headings.' + errorField),
                reason: this.$t('flexben.formErrorReasons.' + invalidReasons[errorField][indexKey])
              }))
            }
          }
        }
      }
      return errorList.join('<br>');
    },
    isScheduledImport() {
      return this.$parent.isScheduledImport();
    },
    disabledEditScheduledImport() {
      return this.$parent.disabledEditScheduledImport();
    },
    scheduleDateFormat(classes, date) {
      if (
        this.maxDateScheduled &&
        moment(date).startOf('day').isAfter(moment(this.maxDateScheduled).startOf('day'))
      ) {
        classes.disabled = true;
      }
      return classes;
    },
    findCalendarTimeInPicker() {
      const picker = this.$refs.picker;
      if (!picker || !picker.$children) {
        return null;
      }
      for (const child of picker.$children) {
        if (
          child.$data &&
          'hour' in child.$data &&
          'minute' in child.$data &&
          'ampm' in child.$data
        ) {
          return child;
        }
      }
      return null;
    },
    applyDisplayedPickerTime(date) {
      if (!date) {
        return date;
      }
      const calendarTime = this.findCalendarTimeInPicker();
      if (!calendarTime) {
        return new Date(date);
      }
      const adjusted = new Date(date);
      adjusted.setHours(calendarTime.getHour());
      adjusted.setMinutes(calendarTime.minute);
      adjusted.setSeconds(calendarTime.second || 0);
      adjusted.setMilliseconds(0);
      return adjusted;
    },
  },
  mounted() {
    if (this.disabledEditScheduledImport()) {
      this.$parent._infoToastScheduledImport(
        this.$t('flexben.import.scheduled_import.info_disabled_edit_title'),
        this.$t('flexben.import.scheduled_import.info_disabled_edit_message'),
        'danger'
      )
    }
  }

}
</script>

<style scoped>
.schedule-request-date-disabled {
  pointer-events: none;
  opacity: 0.7;
}

.schedule-request-date-disabled .text-themed {
  color: #999 !important;
}
</style>
